import { getToken } from '../selectors/tokenSelector';
import Axios from 'axios';
import env from 'config/env';
import fileDownload from 'js-file-download';
import { call, put } from 'redux-saga/effects';
import * as types from 'constants/actionTypes';

const exportUtil = {
    get: function* (url, name) {
        let token = getToken();
        yield put({ type: types.SHOW_DOWNLOADING });

        const headers = {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            timezone_offset: new Date(Date.now()).getTimezoneOffset(),
        };
        
        try {
            // Ensure 'responseType: blob' is placed in the Axios config, not in headers
            const res = yield call(Axios.get, `${env.baseUrl()}${url}`, {
                headers,
                responseType: 'blob'
            });

            // Trigger file download
            yield call(fileDownload, res.data, `${name}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

            yield put({ type: types.HIDE_LOADING });
        } catch (error) {
            console.error("File download failed:", error);
            alert("Failed to download file");
            yield put({ type: types.HIDE_LOADING });
        }
    }
};


export default exportUtil;
